export enum AttachmentType {
    Image = "Image",
    Audio = "Audio",
    Video = "Video",
    Document = "Document"
}